import { Component, OnInit, Inject, ViewChild, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { select } from '@angular-redux/store';
import { Observable, Subscription, throwError } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { Itin } from '../../core/itinerari/itinerari.model';
import { Poi } from '../../core/poi/poi.model';
import { ItinActionService } from '../../core/itinerari/itinerari.action';
import { PoiActionService } from '../../core/poi/poi.action';
import { BreadcrumbService } from 'angular-crumbs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { catchError, tap, first, mergeMap } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Themes } from 'src/app/core/themes/themes.model';
import { GeoPos } from 'src/app/core/geographicalpos/geographicalpos.model';
import { AddAttachComponent } from 'src/app/shared/add-attach/add-attach.component';
import { FailRequestComponent } from 'src/app/shared/fail-request/fail-request.component';
import { SuccessRequestComponent } from 'src/app/shared/success-request/success-request.component';
import { User } from 'src/app/core/users/users.model';
import { Attachments } from 'src/app/core/attachments/attachments.model';
import { AddAvatarComponent } from 'src/app/shared/add-avatar/add-avatar.component';
import { AddVideoComponent } from 'src/app/shared/add-video/add-video.component';
import { CrudAlertService } from 'src/app/services/crud-alert.service';
import { CrudAlertComponent } from 'src/app/shared/crud-alert/crud-alert.component';

export interface DialogData {
  id: any;
  itin_name: object;
  current_lang: string;
}

export interface DialogData_AddAtt {
  current_lang: string;
}

@Component({
  selector: 'app-itinerario-singolo',
  templateUrl: './itinerario-singolo.component.html',
  styleUrls: ['./itinerario-singolo.component.scss']
})
export class ItinerarioSingoloComponent implements OnInit, OnDestroy {
  @ViewChild('titleAudio') title_audio: any;
  @ViewChild('avatar') avatar: any;
  @ViewChild('themesSelection') themes_selection: any;
  @ViewChild('poiSelection') poi_selection: any;
  @ViewChild('picSelection') pic_selection: any;
  @ViewChild('audioSelection') audio_selection: any;
  @ViewChild('docSelection') doc_selection: any;
  @ViewChild('videoSelection') video_selection: any;

  @select(['poi', 'filtered'])
  poi_list_filtered$: Observable<any>;
  poi_list: Poi[] = [];
  @select(['itin', 'current'])
  itin_current$: Observable<Itin>;
  itin_current: Itin;
  @select(['logged', 'logged'])
  user_logged$: Observable<any>;
  user_logged: User;
  @select(['theme', 'list'])
  themes_list$: Observable<any>;
  themes_list: Themes[] = [];
  @select(['geopos', 'list'])
  geopos_list$: Observable<any>;
  geopos_list: GeoPos[] = [];

  current_lang: string = 'it';

  current_id: any;
  current_name: object;

  actual_att_selection = [];
  loading = false;

  subscriptions: Subscription[] = [];

  isDisabled = false;

  constructor(private titleService: Title,
              private route: Router,
              private activateroute: ActivatedRoute,
              private apiservice: ApiService,
              private poiAction: PoiActionService,
              private itinAction: ItinActionService,
              private breadcrumbservice: BreadcrumbService,
              private translate: TranslateService,
              public dialog: MatDialog,
              private crudAlertService: CrudAlertService) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.current_lang = this.translate.currentLang;
      this.translate.use(this.current_lang);
    } else {
      this.translate.use('it');
      this.current_lang = this.translate.currentLang;
    }
    this.translate.get('breadcrumb.admin_single_itin').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.changeLangFunction();
    });
  }

  ngOnInit(): void {
    this.user_logged$.pipe(
      first(),
      mergeMap((user) => {
        this.user_logged = user;
        return this.itin_current$.pipe(first());
      }),
      mergeMap((itin) => {
        this.itin_current = itin;
        if ((this.user_logged.auth_user === 'editor' || this.user_logged.auth_user === 'admin') &&
          (this.itin_current.geopos[0].id !== this.user_logged.geopos[0].id)) {
            this.routerFunction('/');
        }
        this.poiAction.searchPOI(['', [], [this.itin_current.geopos[0].name[this.current_lang]], this.current_lang]);
        this.current_id = this.itin_current.id;
        this.current_name = this.itin_current.itin_name;
        this.changeLangFunction();
        return this.apiservice.checkItinEdits(itin.id).pipe(first());
      }),
      tap((isEdited) => {
        this.isDisabled = isEdited;
      })
    ).subscribe();

    this.subscriptions.push(
      this.poi_list_filtered$.subscribe( list => {
        this.poi_list = [...list];
      }),
      this.themes_list$.subscribe( list => {
        this.themes_list = [...list];
      }),
      this.geopos_list$.subscribe( list => {
        this.geopos_list = [...list];
      })
    );
  }

  ngOnDestroy(): void {
    this.itinAction.setItinCurrent(null);
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  themesSelectionFunction() {
    let options_selected = this.themes_selection.selectedOptions.selected;
    let values_selected = [];
    for (const opt of options_selected) {
      values_selected.push(opt._value);
    }
    this.itin_current.themes = values_selected;
  }

  poiSelectionFunction() {
    let options_selected = this.poi_selection.selectedOptions.selected;
    let values_selected = [];
    for (const opt of options_selected) {
      values_selected.push(opt._value);
    }
    this.itin_current.pois = values_selected;
  }

  checkGeopos(geopos) {
    return geopos.id === this.itin_current.geopos[0].id;
  }

  attachmentSelectionFunction() {
    const values_selected = [];
    if (this.pic_selection !== undefined) {
      for (const opt of this.pic_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.audio_selection !== undefined) {
      for (const opt of this.audio_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.doc_selection !== undefined) {
      for (const opt of this.doc_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.video_selection !== undefined) {
      for (const opt of this.video_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.avatar !== undefined) {
      for (const opt of this.avatar.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }

    this.actual_att_selection = [...values_selected];
  }

  elemDelete() {
    this.dialog.open(DeleteItinDialogContent, {
      width: '450px',
      data: {
        id: this.current_id,
        itin_name: this.current_name,
        current_lang: this.current_lang
      }
    });
  }

  addAtt() {
    const dialogRef = this.dialog.open(AddAttachComponent, {
      width: '450px',
      data: {
        current_lang: this.current_lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.itin_current.attachments.push(result);
      }
    });
  }

  addVid() {
    const dialogRef = this.dialog.open(AddVideoComponent, {
      width: '450px',
      data: {
        current_lang: this.current_lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.itin_current.attachments.push(result);
      }
    });
  }

  addAva() {
    const dialogRef = this.dialog.open(AddAvatarComponent, {
      width: '450px',
      data: {
        current_lang: this.current_lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const avatarIdx = this.itin_current.attachments.findIndex(({avatar}) => avatar);
        if (avatarIdx < 0) {
          this.itin_current.attachments.push(result);
        } else {
          this.itin_current.attachments.splice(avatarIdx, 1, result);
        }
      }
    });
  }

  remAtt() {
    for (const att of this.actual_att_selection) {
      let index_of_att = this.itin_current.attachments.indexOf(att);
      if (index_of_att > -1) {
        this.itin_current.attachments.splice(index_of_att, 1);
      }
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    const geoposFilter = this.itin_current.geopos.length > 0 ?
      [this.itin_current?.geopos[0]?.name[this.current_lang]] :
      [];
    this.poiAction.searchPOI([filterValue, [], geoposFilter, this.current_lang]);
  }

  changeLangFunction(): void {
    this.current_lang = this.translate.currentLang;
    this.titleService.setTitle(this.itin_current.itin_name[this.current_lang] + ' - PRIMIS');
    this.breadcrumbservice.changeBreadcrumb(this.activateroute.snapshot, this.itin_current.itin_name[this.current_lang]);
  }

  checkAttachments(att_list: Attachments[], att_type: string) {
    for (const att of att_list) {
      if ((att.file_type === att_type && att_type !== 'picture') ||
        (att.file_type === att_type && att_type === 'picture' && !att.avatar) ||
        (att_type === 'avatar' && att.avatar)) {
        return true;
      }
    }
    return false;
  }

  singleTypeAttachments(att_list: Attachments[], att_type: string) {
    let single_type_list = [];
    for (const att of att_list) {
      if ((att.file_type === att_type && att_type !== 'picture') ||
        (att.file_type === att_type && att_type === 'picture' && !att.avatar) ||
        (att_type === 'avatar' && att.avatar)) {
        single_type_list.push(att);
      }
    }
    return single_type_list;
  }

  checkDict(array_of_dict, elem_id) {
    let list_of_ids = array_of_dict.map((value) => value.id);
    return list_of_ids.includes(elem_id);
  }

  saveItin() {
    this.loading = true;
    const itinValidityErrors: string[] = this.crudAlertService.checkItinValidity(this.itin_current);
    if (itinValidityErrors === null) {
      this.apiservice.modifyItin(this.itin_current).pipe(
        tap((x: any) => {
          if (x && !x.error) {
            this.itinAction.addOrUpdateItin(x);
            this.loading = false;
            const dialogRef = this.dialog.open(SuccessRequestComponent, {
              width: '450px'
            });
            dialogRef.afterClosed().subscribe(() => this.routerFunction('/lista-itinerari'));
          }
        }),
        catchError(error => {
          this.loading = false;
          this.dialog.open(FailRequestComponent, {
            width: '450px'
          });
          return throwError(error);
        })
      ).subscribe();
    } else if (itinValidityErrors?.length > 0) {
      this.loading = false;
      this.dialog.open(CrudAlertComponent, {
        width: '450px',
        data: {
          alertFields: itinValidityErrors
        }
      });
    }
  }

  routerFunction(path_to_new_page) {
    this.route.navigate([path_to_new_page]);
  }

  onlyAdmin() {
    return (this.user_logged.auth_user === 'admin' || this.user_logged.auth_user === 'superadmin')
  }

  titleAudioDisabled() {
    return this.itin_current.attachments.some(({title_audio}) => title_audio === true);
  }

  titleAudioSelection() {
    const option_selected = this.title_audio.selectedOptions.selected[0]._value;
    const index = this.itin_current.attachments.indexOf(option_selected);
    this.itin_current.attachments[index].title_audio = true;
  }
}

@Component({
  selector: 'deleteitin-dialog-content',
  templateUrl: 'deleteitin-dialog-content.html',
  styleUrls: ['./itinerario-singolo.component.scss']
})
export class DeleteItinDialogContent {
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<DeleteItinDialogContent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private apiservice: ApiService,
    private route: Router,
    public dialog: MatDialog,
    private itinAction: ItinActionService) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteItin() {
    this.loading = true;
    let itin_id = this.data.id;
    this.apiservice.deleteItin(itin_id).pipe(
      tap((x: any) => {
        this.itinAction.deleteItin(itin_id);
        this.loading = false;
        this.dialogRef.close();
        if (x && !x.error) {
          const dialogRef = this.dialog.open(SuccessRequestComponent, {
            width: '450px'
          });
          dialogRef.afterClosed().subscribe(() => this.routerFunction('/lista-itinerari'));
        }
      }),
      catchError(error => {
        this.loading = false;
        this.dialog.open(FailRequestComponent, {
          width: '450px'
        });
        return throwError(error);
      })
    ).subscribe();
  }

  routerFunction(path_to_new_page) {
    this.route.navigate([path_to_new_page]);
  }
}
